import Vue from "vue";
import PurchaseOrderTransformer from "@/transformers/purchase/purchaseOrder";

export default (po, useTransformer) => {
  return Vue.$http
    .get(`purchase/warehouse/requisition_order/${po}/`)
    .then((response) => {
      return useTransformer
        ? PurchaseOrderTransformer.fetch(response.data)
        : response.data;
    });
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchPurchaseOrder.js